export function KpiCard({ label, value, sub, accent = "#0a6ed1", icon: Icon, testId, onClick }) {
  const clickable = typeof onClick === "function";
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter") onClick(); } : undefined}
      className={`group rounded-lg border border-[#e5e9f0] bg-white p-4 shadow-sm transition-all duration-200 hover:shadow-md ${clickable ? "cursor-pointer hover:border-[color:var(--kpi-accent)]" : ""}`}
      style={clickable ? { "--kpi-accent": accent } : undefined}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-medium uppercase tracking-wide text-[#6a6d70]">{label}</span>
        {Icon && <Icon size={16} style={{ color: accent }} className={clickable ? "transition-transform group-hover:scale-110" : undefined} />}
      </div>
      <div className="mt-2 text-3xl font-semibold tracking-tight" style={{ color: accent }}>{value}</div>
      {sub && <div className="mt-1 text-xs text-[#6a6d70]">{sub}</div>}
      {clickable && <div className="mt-1 text-[10px] font-medium text-[#0a6ed1] opacity-0 transition-opacity group-hover:opacity-100">View details →</div>}
    </div>
  );
}
